// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"782f820c","512":"4db5d4bc","545":"35e5e898","821":"7dc1138c"}[chunkId] + ".chunk.js";
};